export const portfolioItemConstants = {
  GETALL_REQUEST: "PORTFOLIO_ITEMS_GETALL_REQUEST",
  GETALL_SUCCESS: "PORTFOLIO_ITEMS_GETALL_SUCCESS",
  GETALL_FAILURE: "PORTFOLIO_ITEMS_GETALL_FAILURE",

  GET_PORTFOLIO_ITEM_BY_ID_REQUEST: "PORTFOLIO_ITEM_GET_BY_ID_REQUEST",
  GET_PORTFOLIO_ITEM_BY_ID_SUCCESS: "PORTFOLIO_ITEM_GET_BY_ID_SUCCESS",
  GET_PORTFOLIO_ITEM_BY_ID_FAILURE: "PORTFOLIO_ITEM_GET_BY_ID_FAILURE",

  GET_PORTFOLIO_ITEMS_BY_PORTFOLIO_ID_REQUEST: "PORTFOLIO_ITEMS_GET_BY_PORTFOLIO_ID_REQUEST",
  GET_PORTFOLIO_ITEMS_BY_PORTFOLIO_ID_SUCCESS: "PORTFOLIO_ITEMS_GET_BY_PORTFOLIO_ID_SUCCESS",
  GET_PORTFOLIO_ITEMS_BY_PORTFOLIO_ID_FAILURE: "PORTFOLIO_ITEMS_GET_BY_PORTFOLIO_ID_FAILURE",

  UPDATE_PORTFOLIO_ITEM_REQUEST: "PORTFOLIO_ITEM_UPDATE_REQUEST",
  UPDATE_PORTFOLIO_ITEM_SUCCESS: "PORTFOLIO_ITEM_UPDATE_SUCCESS",
  UPDATE_PORTFOLIO_ITEM_FAILURE: "PORTFOLIO_ITEM_UPDATE_FAILURE",

  DELETE_REQUEST: "PORTFOLIO_ITEM_DELETE_REQUEST",
  DELETE_SUCCESS: "PORTFOLIO_ITEM_DELETE_SUCCESS",
  DELETE_FAILURE: "PORTFOLIO_ITEM_DELETE_FAILURE",
};
